import { render, staticRenderFns } from "./HistoriqueView.vue?vue&type=template&id=2fd8d52e"
import script from "./HistoriqueView.vue?vue&type=script&lang=js"
export * from "./HistoriqueView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports